import { v4 as uuid } from 'uuid';

import { apiConnectIntegration } from './api';
import { integrationAppData } from './integrationApp';

const ALBATO_PUBLISHER_ID = 14389;
const ALLOWED_ENVS = ['dev', 'pilot'];
const ALBATO_EMBED_URL = 'https://ecal.albato-embedded.net/user/auth/token?session_token={token_from_service}&r=%2Fsolutions%2Fmarketplace%2F440%3Fview_id%3D1%26config_id%3D145';

export function updateIntegrationApps () {
    this.integrationApps = integrationAppData;
    this.observed.integrationApps = uuid();
}

export function searchApp (searchText) {
    const query = searchText?.trim().toLowerCase();
    let filtered = integrationAppData;
    if (query) {
        filtered = integrationAppData.filter(({ app, description }) =>
            app.toLowerCase().includes(query) ||
            description.toLowerCase().includes(query)
        );
    }
    this.integrationApps = filtered;
    this.observed.integrationApps = uuid();
}

export async function getAlbatoToken () {
    const publisher = this.env.userStore.publisher;

    if (publisher?.publisherId !== ALBATO_PUBLISHER_ID || !ALLOWED_ENVS.includes(window.env)) {
        return;
    }

    const response = await apiConnectIntegration({
        token: publisher.token,
        traceId: this.env.traceId,
    });
    console.log('Response -> ',response);
    if (response?.data?.data?.token) {
        const sessionToken = response.data.data.token;
        this.albatoEmbedURL = ALBATO_EMBED_URL.replace('{token_from_service}', sessionToken);
        this.observed.albatoEmbedURL = uuid();
    }
}
